var map = {
	"./advertisement.svg": 1119,
	"./application.svg": 1120,
	"./article.svg": 1121,
	"./articles.svg": 1122,
	"./atm.svg": 1123,
	"./blog.svg": 1124,
	"./book-open.svg": 1125,
	"./branch.svg": 1126,
	"./briefcase-alt.svg": 1127,
	"./broadcast-media.svg": 1128,
	"./brochure.svg": 1129,
	"./call-center.svg": 1130,
	"./cashier.svg": 1131,
	"./chat.svg": 1132,
	"./circle.svg": 1133,
	"./comment-alt-dots.svg": 1134,
	"./comparison-sites.svg": 1135,
	"./credit-card-solid.svg": 1136,
	"./doctor.svg": 1137,
	"./email.svg": 1138,
	"./employee-portal.svg": 1139,
	"./event.svg": 1140,
	"./face-to-face.svg": 1141,
	"./facebook-messenger.svg": 1142,
	"./facebook.svg": 1143,
	"./fax.svg": 1144,
	"./file.svg": 1145,
	"./hr.svg": 1146,
	"./instagram.svg": 1147,
	"./intranet.svg": 1148,
	"./it.svg": 1149,
	"./laboratory.svg": 1150,
	"./lamp.svg": 1151,
	"./laptop-solid.svg": 1152,
	"./letter.svg": 1153,
	"./linkedin.svg": 1154,
	"./manager.svg": 1155,
	"./medical-center.svg": 1156,
	"./medical-device.svg": 1157,
	"./medical-examination.svg": 1158,
	"./meeting-room.svg": 1159,
	"./message-captions.svg": 1160,
	"./mobile-device.svg": 1161,
	"./nurse.svg": 1162,
	"./office.svg": 1163,
	"./patient.svg": 1164,
	"./paycheck.svg": 1165,
	"./payment-gateway.svg": 1166,
	"./paypal.svg": 1167,
	"./pharmacy.svg": 1168,
	"./phone-volume.svg": 1169,
	"./phone.svg": 1170,
	"./point-of-sale.svg": 1171,
	"./portal.svg": 1172,
	"./press-release.svg": 1173,
	"./print.svg": 1174,
	"./question-circle-print.svg": 1175,
	"./question-circle.svg": 1176,
	"./reception.svg": 1177,
	"./search.svg": 1178,
	"./self-service.svg": 1179,
	"./setting.svg": 1180,
	"./shop.svg": 1181,
	"./shopkeeper.svg": 1182,
	"./shopping-cart.svg": 1183,
	"./skype.svg": 1184,
	"./sms.svg": 1185,
	"./social-media.svg": 1186,
	"./star-half-stroke.svg": 1187,
	"./tablet.svg": 1188,
	"./teams.svg": 1189,
	"./third-party.svg": 1190,
	"./tiktok.svg": 1191,
	"./training.svg": 1192,
	"./truck.svg": 1193,
	"./twitter.svg": 1194,
	"./video-conference.svg": 1195,
	"./wallet.svg": 1196,
	"./web-ads.svg": 1197,
	"./website.svg": 1198,
	"./whatsapp.svg": 1199,
	"./word-of-mouth.svg": 1200,
	"./work-station.svg": 1201,
	"./youtube.svg": 1202
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1118;